<div style="display:flex;justify-content:center;align-items:center">
<div class="container">
  <i class="pi pi-globe" style="font-size: 1.2em; font-weight:600; padding-right:0.1em"></i>
  <span
    class="span-btn"
    [ngClass]="language === 'es' ? 'lang-selected' : 'lang-not-selected'"
    (click)="switchLang('es')"
    >ES</span>
  <span>|</span>
  <span class="span-btn"
    [ngClass]="language === 'en' ? 'lang-selected' : 'lang-not-selected'"
    (click)="switchLang('en')">EN</span>
</div>
</div>


